/**
 * Redux state for the Meetings → Print / Download tab.
 *
 * All UI preferences (column order, visibility, `filter` (QueryBuilder tree),
 * sort, PDF settings, table selection) are kept here so an admin sees their
 * previous changes when they return.
 * State is indexed by `projectId` so each project keeps its own configuration.
 *
 * The whole store is persisted via redux-persist (see redux/store.js), and this
 * slice is not blacklisted, so these preferences survive reloads automatically.
 */

export const actions = {
    // Shallow-merge a patch into a project's tab state.
    setPrintDownloadState: ({ projectId, patch }) => ({
        type: 'PRINT_DOWNLOAD_SET_STATE',
        payload: { projectId, patch },
    }),
    // Reset a single project's tab state back to defaults.
    resetPrintDownloadState: ({ projectId }) => ({
        type: 'PRINT_DOWNLOAD_RESET_STATE',
        payload: { projectId },
    }),
};

const initialState = {
    byProject: {},
};

function printDownloadReducer(state = initialState, action) {
    switch (action.type) {
        case 'PRINT_DOWNLOAD_SET_STATE': {
            const { projectId, patch } = action.payload || {};
            if (!projectId) return state;
            return {
                ...state,
                byProject: {
                    ...state.byProject,
                    [projectId]: {
                        ...state.byProject[projectId],
                        ...patch,
                    },
                },
            };
        }
        case 'PRINT_DOWNLOAD_RESET_STATE': {
            const { projectId } = action.payload || {};
            if (!projectId) return state;
            const next = { ...state.byProject };
            delete next[projectId];
            return { ...state, byProject: next };
        }
        default:
            return state;
    }
}

export default printDownloadReducer;
